import React from "react";
import styled from "styled-components";
import bg from "../../images/policies-bg.png";
import TopBanner from "../../Sections/TopBanner/NewTopBanner";
import Policy from "./Policy";
import { FaRegFilePdf } from "react-icons/fa";
import { FiLink2 } from "react-icons/fi";
import { breakpoints } from "../../utils/breakpoints";
import { Link, Outlet } from "react-router-dom";

import newBanner from "../../images/fiveback2025.jpg";
import mobileBanner from "../../images/fiveback2025.jpg";

import reg from "../../images/checkbfile.png";
import files from "../../images/hammer.png";
import agreement from "../../images/distrib.png";
import shield from "../../images/shield.png";
import purchase from "../../images/dollarS.png";

const StyledDiv = styled.div`
	height: auto;
	background-size: cover;
	background: #0A0B0D 0% 0% no-repeat padding-box;
	color: white;

	.content-container {
		padding: 100px 0;

		.row{
			display: grid;
			grid-template-columns: 1fr 1fr;
			row-gap: 20px;
			align-items: center;
			width: 90%;
			margin: auto;
			padding: 20px 0;
			column-gap: 40px
		}

		.policies-container {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			row-gap: 20px;
			align-items: center;
			width: 90%;
			margin: auto;
			padding: 20px 0;
			column-gap: 40px
		}

		 

		.hovered {
			background: transparent
				linear-gradient(
					145deg,
					#44b2dd 0%,
					#84c2e1 100%
				)
				0% 0% no-repeat padding-box;
			border-radius: 50%;

			.icon {
				transform: scale(5);
				transition: transform 30ms;
			}

			.txt {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, 20%);
				font-size: 15px;
			}
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
		.content-container {
			padding: 0;

			.heading {
				padding: 50px 0;
			}

			.row{
				grid-template-columns: 1fr;
				row-gap: 15px;
				justify-items: center;
				padding: 10px 0;
			}

			.policies-container {
				grid-template-columns: 1fr;
				row-gap: 15px;
				justify-items: center;
				padding: 10px 0;
				width: 95%;

			}
		}
	}
`;

const Policies = () => {
	return (
		<>
			<StyledDiv>
				<TopBanner
								bg={
									window.innerWidth < 750
										? mobileBanner
										: newBanner
								}
				
								title={
										<>
										Policies
										</>
									}
				
								
							/>
				<div className="content-container">
					
					<div className="policies-container">
						<Link
							to="compliance#policy-content"
							preventScrollReset={
								true
							}>
							<Policy
								id={1}
								txt={
									"Compliance & Regulatory"
								}
								icon={
									reg
								}
							/>
						</Link>
						
						<a
							href="https://igeniusglobal.io/documents/policies/iGenius-Policies-Procedures.pdf"
							target="_blank"
							rel="noreferrer">
							<Policy
								id={2}
								txt={
									"Policies & Procedures"
								}
								icon={
									files
								}
							/>
						</a>
						
						<Link
							to="distributoragreement#policy-content"
							preventScrollReset={
								true
							}>
							<Policy
								id={3}
								txt={
									"Distributor Agreement"
								}
								icon={
									agreement
								}
							/>
						</Link>
					</div>
					<div class="row">
							<Link
						
							to="privacypolicy#policy-content"
							preventScrollReset={
								true
							}>
							<Policy
								id={4}
								txt={
									"Privacy Policy"
								}
								icon={
									shield
								}
							/>
						</Link>
						
						<Link
							
							to="purchaseterms#policy-content"
							preventScrollReset={
								true
							}>
							<Policy
								id={5}
								txt={
									"Purchase Terms"
								}
								icon={
									purchase
								}
							/>
						</Link>
					</div>
						
						
					
				</div>
			</StyledDiv>
			<div id="policy-content">
				<Outlet />
			</div>
		</>
	);
};

export default Policies;
